// extracted by mini-css-extract-plugin
export var button = "_ob-0";